export const createStickerBlob = async (sourceUrl) => {
  const stickerifyUrl = process.env.REACT_APP_API_STICKERIFY_URL;
  const separator = stickerifyUrl.includes("?") ? "&" : "?";
  const response = await fetch(`${stickerifyUrl}${separator}url=${sourceUrl}`);

  if (!response.ok) {
    throw new Error(`Stickerify request failed with status ${response.status}`);
  }

  return response.blob();
};
